import React, {PropTypes} from 'react';
import {Link} from 'react-router';
import {I18n} from 'react-redux-i18n';

class PetAdOptions extends React.Component {
  render() {
    const {ad, preview, onClear, onUpload} = this.props;
    return (
      <td>
        {ad.isValid && <Link to={preview} target="_blank" className="aspace-preview">{I18n.t('PREVIEW')}</Link>}
        {ad.isValid && <button type="button" className="btn btn-link" onClick={() => onClear(ad)}>{I18n.t('CLEAR')}</button>}
        <label className="custom-file">
          <input type="file" id="file" className="custom-file-input" accept="image/jpeg, image/png" onChange={(e) => {onUpload(ad, e.target.files[0]);}}/>
          <span className="custom-file-control">{I18n.t('UPLOAD')}</span>
        </label>
      </td>
    );
  }
}

PetAdOptions.propTypes = {
  ad: PropTypes.object.isRequired,
  preview: PropTypes.string.isRequired,
  onClear: PropTypes.func.isRequired,
  onUpload: PropTypes.func.isRequired
};

export default PetAdOptions;


/** WEBPACK FOOTER **
 ** ./src/modules/caresheets/components/PetAdOptions.js
 **/